import { Box } from '@mui/material'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  AppDispatch,
  FederalActions,
  FederalSelectors, GrantsActions, GrantsSelectors,
  RootState,
  SmallBusinessSelectors,
  SmallBusinessSliceActions,
} from '../../../../store'
import { FormsSelector } from '../../../../store/forms'
import {
  PrivateFoundationsActions,
  PrivateFoundationsSelectors,
} from '../../../../store/privateFoundations'
import { SearchForm } from '../SearchForm'
import { PrivateFoundationsList, SmallBusinessAndFederalList } from '../SearchResults'
import { SearchTypes } from '../SearchTypes'
import { ResultLayout } from './ResultLayout'

export const GlobalSearch: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const formId = 'global'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))

  const { value = '' } = formValues

  const smallBusinessLoading = useSelector(SmallBusinessSelectors.getLoading)
  const smallBusinessGrants = useSelector(SmallBusinessSelectors.makeSmallBusinessGrants)

  const federalLoading = useSelector(FederalSelectors.getLoading)
  const federalGrants = useSelector(FederalSelectors.makeFederalGrants)

  const PFsLoading = useSelector(PrivateFoundationsSelectors.getLoading)
  const PFs = useSelector(PrivateFoundationsSelectors.makePrivateFoundations)

  const agencies = useSelector(GrantsSelectors.getSelectedAgencies)
  const phases = useSelector(GrantsSelectors.getSelectedPhases)
  const statuses = useSelector(GrantsSelectors.getSelectedStatuses)
  const startDate = useSelector(GrantsSelectors.getStartDate)
  const endDate = useSelector(GrantsSelectors.getEndDate)

  const handleFiltersChange = (filters:any) => {
    dispatch(GrantsActions.setFilters(filters))
    dispatch(SmallBusinessSliceActions.setFilters(filters))
    dispatch(FederalActions.setFilters(filters))
  }

  const handleSearch = () => {
    dispatch(FederalActions.resetPaging())
    dispatch(PrivateFoundationsActions.resetPaging())
    dispatch(SmallBusinessSliceActions.resetPaging())

    dispatch(
      PrivateFoundationsActions.fetchPrivateFoundationsAsync({
        options: {
          params: {
            searchedText: value,
            $limit: 25,
            $skip: 0,
          },
        },
      }),
    )

    const options = {
      params: {
        query: value,
        $limit: 25,
        $skip: 0,
        $sort: 'score desc',
        $includes: 'solicitation, agency',
      },
    }

    const isoStartDate = startDate && startDate.format().split('T')[0] + 'T00:00:00Z'
    const isoEndDate = endDate && endDate.format().split('T')[0] + 'T00:00:00Z'

    const payload = {
      agencies,
      phases,
      statuses,
      startDate: isoStartDate,
      endDate: isoEndDate,
    }

    dispatch(FederalActions.fetchFederalGrantsAsync({payload, options }))
    dispatch(SmallBusinessSliceActions.fetchSmallBusinessGrantsAsync({payload, options }))
  }

  return (
    <Box>
      <SearchForm
        filters={{
          agencies,
          statuses,
          phases,
          deadline: {
            startDate,
            endDate
          }
        }}
        formId="global"
        onSearch={handleSearch}
        heading="Browse for your next grants"
        handleFiltersChange={handleFiltersChange}
        loading={smallBusinessLoading || federalLoading || PFsLoading}
      />

      <SearchTypes />

      {federalGrants && !!federalGrants.length && (
        <ResultLayout
          formValue={value}
          searchType="federal"
          heading="Federal Opportunities"
          resultComponent={<SmallBusinessAndFederalList result={federalGrants.slice(0, 3)} />}
        />
      )}

      {smallBusinessGrants && !!smallBusinessGrants.length && (
        <ResultLayout
          formValue={value}
          heading="Small Business"
          searchType="smallBusiness"
          resultComponent={<SmallBusinessAndFederalList result={smallBusinessGrants.slice(0, 3)} />}
        />
      )}

      {PFs && !!PFs.length && (
        <ResultLayout
          formValue={value}
          searchType="privateFoundations"
          heading="Private Foundations"
          resultComponent={<PrivateFoundationsList result={PFs.slice(0, 3)} />}
        />
      )}
    </Box>
  )
}
